// extracted by mini-css-extract-plugin
export default {"topics":"apz4AN2n","topicsList":"SAdyf4P2"};